import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useInfiniteQuery } from "react-query";
import { ExecucaoOrcamentaria, ExecucaoOrcamentariaParams } from "../typings";

export default function useExecucaoOrcamentaria(
  query: ExecucaoOrcamentariaParams
) {
  return useInfiniteQuery<PaginateResult<ExecucaoOrcamentaria>, AxiosError>(
    [`/v1/execucao-orcamentaria`, query],
    async ({ pageParam }) => {
      const { data } = await http.get<PaginateResult<ExecucaoOrcamentaria>>(
        "/v1/execucao-orcamentaria",
        {
          params: { ...query, page: pageParam },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}
